import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import {  NavParams, ViewController } from 'ionic-angular';
import { AlertMessager } from '../../lib/alertMessager';
import { DataService } from '../../services/data';
import { HorseService } from '../../services/horse.service';
import { Account } from '../../model/account';
import { Horse } from '../../model/horse';
import { HorseBreeder } from '../../model/horseBreeder';
import { HorseOwner } from '../../model/horseOwner';
import { Organization } from '../../model/organization';
import { Rodeo } from '../../model/rodeo';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html'
})
export class SearchComponent implements OnInit {
    @ViewChild('searchbar') searchbar;
    @Input() config: {
        searchTitle: string;
        horseSearch: boolean;
        breederSearch: boolean;
        userSearch: boolean;
        ownerSearch: boolean;
        addNew: boolean;
        rodeoSearch: boolean;
    };
    @Input() userHorses?: boolean;
    @Input() userIds?: number[];
    @Input() siresOnly?: boolean;
    @Input() damsOnly?: boolean;
    @Input() organizations?: Organization[];
    @Input() accountSearchList: Account[];
    @Input() rodeoSearchList?: Rodeo[];

    searchValue: string;
    displayItems: any[];

    horses: Horse[];

    isLoading = false;
    private staff = false; //not used because this is client app

    constructor(
        private navParams: NavParams,
        private data: DataService,
        private alert: AlertMessager,
        private horseService: HorseService,
        private viewCtrl: ViewController
    ) {
        this.config = navParams.get('config');
        this.userHorses = navParams.get('userHorses');
        this.userIds = navParams.get('userIds');
        this.siresOnly = navParams.get('siresOnly');
        this.damsOnly = navParams.get('damsOnly');
        this.organizations = navParams.get('organizations');
        this.accountSearchList = navParams.get('accountSearchList');
        this.rodeoSearchList = navParams.get('rodeoSearchList');
    }

    ngOnInit(): void {
        if (this.userIds)
            this.userIds = Array.from(new Set(this.userIds.filter(x => x)));
    }

    ionViewDidEnter() {
        const element = this.searchbar._elementRef.nativeElement.querySelector('input');
        // we need to delay our call in order to work with ionic ...
        setTimeout(() => {
            //this.renderer.invokeElementMethod(element, 'focus', []);
            (element as any)['focus'].apply(element, []);
        }, 0);
    
        this.search();
    }

    async closeWithNew() {
        if (this.config.horseSearch) {
            let newHorse = new Horse();
            newHorse.name = this.searchValue;
            await this.close(newHorse);
        } else if (this.config.breederSearch) {
            let newBreeder = new HorseBreeder();
            newBreeder.name = this.searchValue;
            await this.close(newBreeder);
        } else if (this.config.ownerSearch) {
            let newOwner = new HorseOwner();
            newOwner.name = this.searchValue;
            await this.close(newOwner);
        } else if (this.config.rodeoSearch) {
            let newRodeo = new Rodeo();
            newRodeo.name = this.searchValue;
            await this.close(newRodeo);
        } else {
            let firstName = this.searchValue;
            let lastName = '';
    
            if (this.searchValue.indexOf(' ') > 0) {
                firstName = this.searchValue.split(' ')[0];
                lastName = this.searchValue.split(' ')[1];
            }
    
            let newAccount = new Account();
            newAccount.firstName = firstName;
            newAccount.lastName = lastName;
            await this.close(newAccount);
        }
    }

    async close(data: any = null) {
        await this.viewCtrl.dismiss(data);
    }

    async search() {
        this.isLoading = true;

        if (this.userHorses) {
            this.horses = await this.horseService.getHorses(this.userIds);
        }

        if (!this.searchValue || this.searchValue === '') {
            if (this.config.horseSearch)
                this.displayItems = this.horses;
            else
                this.displayItems = null;
        } else {
            if (this.config.horseSearch) {
                if (this.userHorses) {                    
                    this.displayItems = this.horses.filter(x => x.name.toLocaleLowerCase().indexOf(this.searchValue.toLocaleLowerCase()) != -1);
                } else {
                    this.displayItems = await this.horseService.searchHorses(this.searchValue, this.siresOnly, this.damsOnly);
                }
            } else if (this.config.breederSearch) {
                this.displayItems = await this.horseService.searchBreeders(this.searchValue);
            } else if (this.config.ownerSearch) {
                this.displayItems = await this.horseService.searchOwners(this.searchValue);
            } else {
                this.searchForUser();
            }
        }

        this.isLoading = false;
    }

    async searchForUser() {
        if (!this.searchValue || this.searchValue === '') {
            this.displayItems = null;
        } else {
            const search = this.searchValue.trim().toLocaleLowerCase();
            let firstName = search;
            let lastName = '';

            if (search.indexOf(' ') > 0) {
                firstName = search.split(' ')[0];
                lastName = search.split(' ')[1];
            }

            if (this.accountSearchList) {
                this.displayItems = this.accountSearchList.filter(x => x.firstName.toLocaleLowerCase().indexOf(firstName) != -1 && x.lastName.toLocaleLowerCase().indexOf(lastName) != -1);
            } else {
                try {
                    this.displayItems = await this.data.getUserSearch(firstName, lastName);
                } catch (error) {
                    this.alert.showError('Error', 'Unable to retrieve search results: ' + error)
                }
            }
        }
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 13 && this.displayItems) {
            if (this.displayItems.length > 0)
                this.close(this.displayItems[0]);
            else if (this.config.addNew)
                this.closeWithNew();
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/search/search.component.ts